import LabelStatus from 'components/ui/labelStatus';
import { Skeleton } from 'components/ui/skeleton';

export const MafListDemonstration = () => (
  <div className='flex max-w-[500px] min-w-[300px] flex-col'>
    <div className='border-border-base flex h-10 items-center justify-between rounded-[--component-table-border-radius] rounded-tr-none rounded-br-none border border-r-0 px-2'>
      <div className='text-brand-main'>Fill Out</div>
      <Skeleton width='45px' height='10px' />
      <div>
        <LabelStatus status='success' text='new' />
      </div>
      <Skeleton width='45px' height='10px' />
    </div>
    <div className='text-l-bold m-4'>OR</div>
    <div className='border-border-base flex h-10 items-center justify-between rounded-[--component-table-border-radius] rounded-tr-none rounded-br-none border border-r-0 px-2'>
      <div className='text-brand-main'>Fill Out</div>
      <Skeleton width='45px' height='10px' />
      <div>
        <LabelStatus status='active' text='in progress' />
      </div>
      <Skeleton width='45px' height='10px' />
    </div>
  </div>
);
